<template>
  <!--    request-detail 组件 -->
  <request-detail
    :formData="basicInfoData"
    :formModel_R="formModel_R"
    :formModel_S="formModel_S"
    @clickSubmit="clickSubmit"
    :model="model"
  ></request-detail>
</template>

<script>
import RequestDetail from '../components/request-detail/request-detail'
import { getCssSubmit, getCusInfo } from './api'
import config from '@/config'

export default {
  name: 'css-detail',
  components: { RequestDetail },
  data() {
    const formModel_R = [
      {
        label: 'Credit Request Type',
        type: 'select',
        key: 'requestType',
        value: 1,
        change: (val, form) => this.handleSelectChange(val, form),
        rules: [
          { required: true, message: 'Can not be empty!', trigger: 'blur' },
        ],
        selectList: [
          {
            id: 1,
            name: 'Line Of Credit',
          },
          {
            id: 2,
            name: 'Other',
          },
        ],
      },
      {
        label: 'Credit Category',
        type: 'select',
        key: 'creditCategory',
        rules: [
          { required: true, message: 'Can not be empty!', trigger: 'blur' },
        ],
        value: '',
        selectList: [
          { id: 1, name: 'BAU' },
          { id: 2, name: 'Uplift' },
        ],
      },
      {
        style: { display: 'block' },
        label: 'Request Amount($)',
        rules: [
          { required: true, message: 'Can not be empty!', trigger: 'blur' },
        ],
        type: 'input',
        value: '',
        key: 'requestAmount',
        input: value => this.handleChange(value),
      },
    ]
    const formModel_S = [
      // {
      //   label: '',
      //   type: 'textarea',
      //   key: 'remark',
      //   rules: [
      //     {
      //       min: 0,
      //       max: 20000,
      //       message: 'No more than 20000 characters.',
      //       trigger: 'blur',
      //     },
      //   ],
      // },
    ]
    return {
      uploadUrl: `${config.baseApi}/workflow-api/credit-apply/attachment/upload`,
      formModel_R: formModel_R, // 详情页credit request的formModel
      formModel_S: formModel_S,
      allData: {},
      disabled: false,
      model: {},
      basicInfoData: [],
      basicInfoKeys: [
        'code',
        'name',
        'businessStr',
        'regionStr',
        'countryStr',
        'paymentTermReq',
      ], // 不需要所有的数据，根据原型把需要的key挑出来
    }
  },
  mounted() {
    const params = {
      id: this.$route.params.customerId,
    }
    this.$route.params.customerId && this._getCusInfo(params)
  },
  methods: {
    async handleChange(value) {
      value = this.$utils.setSeperatenum(value)
      this.formModel_R = this.formModel_R.map(item => {
        if (item.key === 'requestAmount') {
          item.value = value
        }
        return item
      })
    },
    async _getCusInfo(params) {
      try {
        const res = await getCusInfo(params)
        if (res && res.companyInfoVO) {
          this.allInfo = res
          this.filterData(res)
        }
      } catch (err) {
        this.$message.error(err)
        this.$router.push('/credit-management/credit-request/home')
      }
    },
    //对数据进行摘取
    filterData(allData) {
      // 对basic info操作
      if (allData.companyInfoVO) {
        const _basicInfoData = []
        Object.keys(allData.companyInfoVO).forEach(key => {
          if (this.basicInfoKeys.indexOf(key) !== -1) {
            const obj = {}
            obj.key = key
            obj.value = allData.companyInfoVO[key]
            _basicInfoData.push(obj)
          }
        })
        this.basicInfoData = _basicInfoData
      }
    },
    // 点击事件
    clickSubmit(paramsObj) {
      this.isLoading = true
      const arr = []
      paramsObj.fileList.forEach(item => {
        arr.push(item.response.data)
      })
      try {
        const params = {
          attachmentIds: paramsObj.fileList.length ? arr : [],
          companyId: this.$route.params.customerId,
          loanAmount: {
            amount: this.$utils.resetAmount(paramsObj.amount),
          },
          remark: paramsObj.remark,
          type: paramsObj.type,
          requestType: paramsObj.requestType,
        }
        if (params.requestType === 2) {
          params.loanAmount.amount = ''
          this.handleSubmit(params)
        } else {
          this.handleSubmit(params)
        }
      } catch (err) {
        console.log(err)
      }
    },
    // 提交credit request
    async handleSubmit(params) {
      try {
        await getCssSubmit(params)
        this.$message.success('Success')
        await this.$router.push('/credit-management/credit-request/query')
      } catch (e) {
        console.log(e)
      }
    },
    // credit request type 联动
    handleSelectChange(val, form) {
      if (val === 2) {
        this.model = { ...form, creditCategory: '' }
        this.formModel_R = this.formModel_R.map(item => {
          if (item.key === 'requestAmount') {
            item.style.display = 'none'
            delete item.rules
          }
          return item
        })
        const _selectList = [
          { id: 4, name: 'PCR' },
          { id: 5, name: 'Condition Update' },
          { id: 6, name: 'Waiver' },
          { id: 7, name: 'Invoice Extension' },
        ]
        this.formModel_R = this.formModel_R.map(item => {
          if (item.key === 'creditCategory') {
            item = { ...item, selectList: _selectList }
          }
          return item
        })
      } else if (val === '') {
        this.formModel_R = this.formModel_R.map(item => {
          if (item.key === 'creditCategory') {
            item.selectList = []
            item.value = ''
          }
          return item
        })
        this.model = { ...form, creditCategory: '' }
      } else {
        this.model = { ...form, creditCategory: '' }
        this.formModel_R = this.formModel_R.map(item => {
          if (item.key === 'requestAmount') {
            item.rules = {
              required: true,
              message: 'Can not be empty!',
              trigger: 'blur',
            }
            item.style.display = 'block'
          }
          return item
        })
        const __selectList = [
          { id: 1, name: 'BAU' },
          { id: 2, name: 'Uplift' },
        ]
        this.formModel_R = this.formModel_R.map(item => {
          if (item.key === 'creditCategory') {
            item = { ...item, selectList: __selectList }
          }
          return item
        })
      }
    },
  },
}
</script>

<style scoped lang="less"></style>
